export const NotificationConstants = {
    default_message: "Something went wrong, please try again."
}
